import styled from "styled-components";
import { palette, fonts, radii } from "../../styles/palette";

// Alerta para móviles (no se puede cerrar)
export const MobileAlertOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 5000;
  background: ${palette.overlayLight};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
`;

export const MobileAlertCard = styled.div`
  background: ${palette.white};
  border: 1px solid ${palette.border};
  border-radius: ${radii.md};
  padding: 28px 24px;
  max-width: 400px;
  width: 100%;
  box-shadow: 0 18px 48px rgba(35, 35, 35, 0.18);
  position: relative;
`;

export const MobileAlertTitle = styled.div`
  font-family: ${fonts.heading};
  font-size: 20px;
  font-weight: 600;
  color: ${palette.navy};
  margin-bottom: 16px;
  text-align: center;
`;

export const MobileAlertMessage = styled.div`
  font-size: 16px;
  color: ${palette.textSecondary};
  line-height: 1.5;
  margin-bottom: 20px;
  text-align: center;
`;

export const MobileAlertInstruction = styled.div`
  font-size: 15px;
  color: ${palette.navy};
  line-height: 1.4;
  margin-bottom: 20px;
  text-align: center;
  font-weight: 500;
`;

export const AcademyButton = styled.a`
  width: 100%;
  background: ${palette.red};
  color: ${palette.white};
  border: none;
  border-radius: ${radii.pill};
  padding: 12px 24px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-top: 16px;
  text-decoration: none;
  display: block;
  text-align: center;
  box-shadow: 0 4px 14px ${palette.redGlow};

  &:hover {
    background: ${palette.redHover};
    transform: translateY(-1px);
    box-shadow: 0 6px 18px ${palette.redGlow};
    color: ${palette.white};
    text-decoration: none;
  }

  &:active {
    transform: translateY(0);
  }

  &:visited {
    color: ${palette.white};
  }
`;
